import { ScreenerFilter } from '@api/api/screener';
import { useTranslation } from 'react-i18next';

export const SCENARIO_ASSET_FILTER_KEY = 'scenario_assets';

export const useScenarioEntityFilters = (): ScreenerFilter[] => {
  const { t } = useTranslation(['common']);

  const assetFilter: ScreenerFilter = {
    key: SCENARIO_ASSET_FILTER_KEY,
    name: t('common:filters.assets', { count: 2 }),
    visible: true,
    searchable: true,
    category: 'Universe',
    locked: true,
    config: {
      multiselect: false,
      name: t('common:filters.assets', { count: 2 }),
      options: [],
    },
  };

  return [assetFilter];
};
